import { Directive, ElementRef, Input, TemplateRef } from '@angular/core';

@Directive({selector: '[queryButtonGroup]'})
export class QueryButtonGroupDirective {
  constructor(public template: TemplateRef<any>) {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/query-builder/query-button-group.directive.ts